import { logger } from '@src/logger';
import { getWindow } from '@shared/services/window';
import { Constants } from './constants';
import { SpzaInstrumentService } from '@shared/services/telemetry/spza/spzaInstrument';
import { stringifyError } from './errorUtils';
// special params which are also campaign ones
export const specialParams = [
    'debug',
    'preview',
    'embedHost',
    'fullScreenMode',
    Constants.QueryStrings.includeTestProducts,
    Constants.QueryStrings.isConverged
];
export const campaignParams = [
    'mktcmpid',
    'mktvid',
    'ref',
    'src',
    'campaignCorrelationId',
    'embedCorrelationId',
    'mkt_tok',
    'utm_source',
    'utm_medium',
    'utm_term',
    'utm_content',
    'utm_campaign',
    'source',
    'placement',
    'ad_id',
    'adset_id',
    'campaign_id',
    'ad_name',
    'adset_name',
    'campaign_name',
    'fb',
    'ig',
    'msg',
    'an',
    'ocid'
];
export const excludedCampaignsForAcquisition = [
    {
        src: 'office'
    }
];
const logGetCampaignTelemetry = ({ landingView, currentView, shouldSkipGetCampaigns, campaigns, entityId, error })=>{
    let detailText;
    if (error) {
        detailText = 'Failed Generating Campaigns Before Passing To Lead, ' + `LANDING VIEW: ${landingView}, ` + `CURRENT VIEW: ${currentView}, ` + `ERROR: ${stringifyError(error)}`;
    } else if (shouldSkipGetCampaigns) {
        detailText = 'Success Skipping Generating Campaigns Before Passing To Lead, ' + `LANDING VIEW: ${landingView}, ` + `CURRENT VIEW: ${currentView}, ` + `CAMPAIGNS: ${JSON.stringify(campaigns)}`;
    } else {
        detailText = 'Success Generating Campaigns Before Passing To Lead, ' + `LANDING VIEW: ${landingView}, ` + `CURRENT VIEW: ${currentView}, ` + `CAMPAIGNS: ${JSON.stringify(campaigns)}`;
    }
    const payload = {
        page: currentView,
        action: Constants.Telemetry.Action.PublishAcquisitionInfo,
        actionModifier: Constants.Telemetry.ActionModifier.LeadCampaignGeneration,
        appName: entityId,
        details: detailText
    };
    SpzaInstrumentService.getProvider().probe('logTelemetryInfo', payload);
    logger.info(payload.details, {
        action: payload.action,
        actionModifier: payload.actionModifier,
        appName: entityId,
        page: payload.page
    });
};
// returns the list of the valid route params for app view.
export const getAppViewParams = ()=>{
    return specialParams.concat(campaignParams);
};
function getParameterByName(param, url) {
    param = param.replace(/[\\[\]]/g, '\\$&');
    const regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)', 'i');
    const results = regex.exec(url);
    if (!results) {
        return null;
    }
    // 2 represents the value of the param.
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
// 1) we should always generate, after user redirects to a non-detail page from a campaign
// 2) we should generate current and only current, if user redirects to a detail page from a campaign
export const shouldGetCampaignsForAcquistion = (landingView, previousPage, routes)=>{
    const isInitiaViewDetailPage = landingView === routes.appDetails.name || landingView === routes.serviceDetail.name;
    const isCurrentViewLandingView = !previousPage;
    return !isInitiaViewDetailPage || isCurrentViewLandingView;
};
function serializeCampaignObject(obj) {
    const str = [];
    for(const p in obj){
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[`${p}`]));
    }
    return str.join('&');
}
export const extractCampaignsFromUrl = (url)=>{
    const campaigns = {};
    for(let i = 0; i < campaignParams.length; i++){
        const campaignParam = getParameterByName(campaignParams[`${i}`], url);
        if (campaignParam) {
            campaigns[campaignParams[`${i}`]] = campaignParam;
        }
    }
    return campaigns;
};
export const excludeCampaignsForAcquisition = (campaigns)=>{
    const keys = Object.keys(campaigns);
    keys.forEach((key)=>{
        const value = campaigns[`${key}`];
        const foundToDelete = excludedCampaignsForAcquisition.some((aExludeCampaign)=>{
            const excludeKey = Object.keys(aExludeCampaign)[0];
            const excludeValue = aExludeCampaign[`${key}`];
            return key === excludeKey && value === excludeValue;
        });
        if (foundToDelete) {
            delete campaigns[`${key}`];
        }
    });
};
export const getCampaignsForAcquisitionFromUrl = ({ url, landingView, currentView, previousPage, routes, entityId })=>{
    try {
        if (!shouldGetCampaignsForAcquistion(landingView, previousPage, routes)) {
            logGetCampaignTelemetry({
                landingView,
                currentView,
                shouldSkipGetCampaigns: true,
                campaigns: null,
                error: null,
                entityId
            });
            return null;
        }
        const campaigns = extractCampaignsFromUrl(url);
        excludeCampaignsForAcquisition(campaigns);
        logGetCampaignTelemetry({
            landingView,
            currentView,
            shouldSkipGetCampaigns: false,
            campaigns,
            error: null,
            entityId
        });
        return campaigns;
    } catch (error) {
        logGetCampaignTelemetry({
            landingView,
            currentView,
            shouldSkipGetCampaigns: false,
            campaigns: null,
            error,
            entityId
        });
        return null;
    }
};
// This methods returns just the campaign params from the URL
// for e.g. if the URL is http://localhost:3000/en-us/home?debug=true&mktcmpid=foo&mktvid=bar
// the output would be mktcmpid=foo&mktvid=bar
function getCampaingQueryParamsFromUrl(url) {
    const campaignObj = extractCampaignsFromUrl(url);
    return serializeCampaignObject(campaignObj);
}
export function updateHandOffUrlWithCampaignParams(handoffUrl) {
    var _getWindow_location, _getWindow;
    if (!handoffUrl) {
        return;
    }
    const params = getCampaingQueryParamsFromUrl((_getWindow = getWindow()) === null || _getWindow === void 0 ? void 0 : (_getWindow_location = _getWindow.location) === null || _getWindow_location === void 0 ? void 0 : _getWindow_location.href);
    if (params) {
        if (handoffUrl.indexOf('?') >= 0) {
            handoffUrl = handoffUrl.replace('?', `?${params}&`);
        } else {
            handoffUrl = handoffUrl + '?' + params;
        }
    }
    return handoffUrl;
}
export const getEntityIdFromUrl = ({ pathName = '' })=>{
    let offerIdLocation = 0;
    let entityId = '';
    offerIdLocation = pathName.lastIndexOf('/');
    entityId = pathName.substring(offerIdLocation + 1).split('?')[0];
    return entityId;
};
